export default "__VITE_ASSET__C93g2As4__"